import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CoreService } from '../../services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { CoreVm, UpdateColumnCoreVm, FilteredCoreVm } from 'src/app/viewModels/core/core-vm';
import { Observable, Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { CdkDragStart, moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { MessageTemplate, ModuleName } from '../../services/coreService/core.enum';
import { FormControl } from '@angular/forms';
import { PaycheckErrorComponent } from 'src/app/middleware/common/paycheckError/paycheckError.component';
import { forEach } from 'jszip';

@Component({
  selector: 'app-core-listing',
  templateUrl: './core-listing.component.html',
  styleUrls: ['./core-listing.component.scss'],
  providers: [DatePipe],
})

export class CoreListingComponent implements OnInit {
  public editorConfig = {
    versionCheck: false
  };
  currentUser: any;
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  coreList: any[] = [];
  Allids: any[] = [];
  coreFieldList: any[] = [];
  coreFieldListNew: any[] = [];
  coreFieldColumnToogle: any[] = [];
  ToogleColumnFields: any[] = [];
  coreListNew: any[] = [];
  addListing: boolean = false;
  value = '';
  clickEventsubscription: Subscription;
  clickEventsubscription1: Subscription;
  clickEventsubscription2: Subscription;
  coreUserListReceived = false;
  coreListReceived = false;

  displayedColumns: string[] = [];
  displayHidden: string[] = [];
  dataSource: any;

  _returnList: any[] = [];
  _returnList1: any[] = [];
  _returnColumns: any[] = [];
  clmshow: boolean = false;

  coreFilterNameList: any[] = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  previousIndex: number;
  closelist: boolean = false;
  showFilter: boolean = false;
  showSearch: boolean = false;
  showDetail: boolean = false;
  showSavedFilter: boolean = false;
  globalSort: Sort;
  filterText: any;
  targetList: any;
  filteredList: any;
  totalCount: any;
  paginatorTotalLength: any;
  isAnyRecordAvailable: boolean = false;
  dataCount: any;
  currentData: any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 20,
    searchValue: '',
  };

  corefilterData = {
    userID: '',
    organizationID: 0,
    databaseID: 0,
    folderID: 0,
    officeID: 0,
    OfficeIDList: [],
  };

  getUserPreferencesModel = {
    userID: '',
    organizationID: 0,
  }

  addUserPreferencesModel = {
    userPreferenceID: 0,
    key: '',
    value: '',
    userID: '',
    createdBy: '',
    OfficeIDList: [],
    officeID: 0
  }

  pageIndex: any;
  pageSize: any;
  SendFilteredNameFromCore: string = "";

  FilteredfieldsRequestModel: any = [];
  FiltersCompanyDataList: any[] = [];

  Filtername: string = '';
  fieldFolderType: any;
  selectedfilterList: any[] = [];
  selectedtransactionId: number = 0;
  closeFilterPanel: string = '';
  Module: string;

  deleteCoreModel = {
    coreID: [],
    userID: '',
    databaseID: 0,
    organizationID: 0,
    folderID: 0,
    officeID: 0,
    OfficeIDList: []
  };

  FavoriteCoreModel = {
    coreID: [],
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID: 0,
    OfficeIDList: []
  };


  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  folderID: any;
  columnData: any[] = [];
  diplayList: any[] = [];
  checkRecentFilter: any[] = [];
  checkDefaultFilter: any[] = [];

  isChecked = false;
  selected = [];
  coreRelationsList: any = [] = [];
  subject: string = "";
  msg: string = "";
  OfficeIDList: any = [];
  myOfficeID: any;

  stateCtrl = new FormControl();
  filteredStates: Observable<any[]>;

  associatedAPIs: any = [] = [];
  showPaycheck: boolean = false;
  payChekSubmittedResult: any;
  isReCreate: boolean = false;
  showPCC: boolean = false;

  mainModuleName:string="Core";

  showListing:boolean=true;  
  showGridListing:boolean=false;  
 
  constructor(private dialog: MatDialog, private statusConst: StatusConstant, private loaderService: LoaderService,
    private coreService: CoreService, private toastr: ToastrService, private coreVm: CoreVm, private filteredCoreVm: FilteredCoreVm,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    public _ChangeDetectorRef: ChangeDetectorRef, private router: Router, private updateColumnCoreVm: UpdateColumnCoreVm,
    public datepipe: DatePipe, private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();
  }

  ngOnInit(): void {
    sessionStorage.setItem('edashboard', "false");
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));
    this.permissionAsssign = this.permissionAsssign.filter((x) => x.mainModuleName == ModuleName.Core && x.isAssign == true);
    if (this.permissionAsssign.length == 0) {
      this.router.navigate(['unauthorised']);
      return;
    }

    this.FilteredfieldsRequestModel = [];
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
      this.folderID = Module[0].folderID;
    }


    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    if (this.associatedAPIs.length > 0) {
      var checkPayCheck = [];
      var checkPCC = [];

      checkPayCheck = this.associatedAPIs.filter(x => x.apiName == 'Paychex' && x.isCoreMapped == true);
      if (checkPayCheck.length > 0) {
        this.showPaycheck = true;
      } else {
        this.showPaycheck = false;
      }

      checkPCC = this.associatedAPIs.filter(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }

    this.FilteredfieldsRequestModel = [];
    sessionStorage.setItem('HeaderModuleName', this.Module);
    this._dataSharingService.sendSelectedModuleName(this.Module);
    this.clickEventsubscription = this._dataSharingService.getSaveUserForCore().subscribe(() => {
      this.getList("");
    });

    this.getAllCoreTypeNameFilter();
    this.clmshow = false;
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }

  GetUserPreferences() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.coreService.getUserPreferences(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.checkRecentFilter = [];
        this.checkDefaultFilter = [];
        this.FiltersCompanyDataList = [];
        this.isAnyRecordAvailable = true;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var getdata = this.responseHolder.data;

          var AllCore = {
            filterID: 0,
            filterName: "All " + this.Module,
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          var AllFav = {
            filterID: -1,
            filterName: "Starred",
            folderID: this.folderID,// 17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }


          this.FiltersCompanyDataList.push(AllCore);//this.AllCore;      

          if (getdata) {
            this.checkRecentFilter = getdata.filter(x => x.key === "CoreRecentFilter");
            this.checkDefaultFilter = getdata.filter(x => x.key === "CoreDefaultFilter");
            this.coreFilterNameList;
            if (this.checkDefaultFilter.length > 0) {
              for (var user = 0; user < this.coreFilterNameList.length; user++) {
                if (this.coreFilterNameList[user].filterID == Number(this.checkDefaultFilter[0].value)) {
                  this.coreFilterNameList[user].isDefault = true;
                }
                else {
                  this.coreFilterNameList[user].isDefault = false;
                }
              }
            }

            // var check=[];
            // check= this.FiltersCompanyDataList.filter(x => x.isDefault === true);
            // if(check.length>0){
            //   this.coreFilterNameList.find((item) => item.filterID == check[0].filterID).isDefault = check[0].isDefault;            
            // }

            this.coreFilterNameList;
            this.FiltersCompanyDataList;
            if (this.checkRecentFilter.length == 0 && this.checkDefaultFilter.length == 0) {
              this.getList('');
              this.Filtername = "All " + this.Module;
              return;
            }

            else if (this.checkRecentFilter.length > 0 && this.checkDefaultFilter.length > 0) {
              var DefaultFilter = this.coreFilterNameList.filter(x => x.filterID === Number(this.checkDefaultFilter[0].value));
              if (DefaultFilter.length > 0) {
                if (DefaultFilter[0].filterID == "-1") {
                  this.getFavoriteCoreList("");
                  this.Filtername = "Starred";
                }
                else if (DefaultFilter[0].filterID == "0") {
                  this.getList("");
                  this.Filtername = "All " + this.Module;
                }
                else if (DefaultFilter[0].filterID > "0") {
                  this.FilteredList(DefaultFilter[0].filterFieldModels);
                  this.Filtername = DefaultFilter[0].filterName;
                }
              }
              return;
            }
            else if (this.checkRecentFilter.length == 0) {
              var DefaultFilter = this.coreFilterNameList.filter(x => x.filterID === Number(this.checkDefaultFilter[0].value));

              if (DefaultFilter.length > 0) {
                if (DefaultFilter[0].filterID == "-1") {
                  this.getFavoriteCoreList("");
                  this.Filtername = "Starred";
                }
                else if (DefaultFilter[0].filterID == "0") {
                  this.getList("");
                  this.Filtername = "All " + this.Module;
                }
                else if (DefaultFilter[0].filterID > "0") {
                  this.FilteredList(DefaultFilter[0].filterFieldModels);
                  this.Filtername = DefaultFilter[0].filterName;
                }
              }
              return;
            }

            else if (this.checkDefaultFilter.length == 0) {
              var RecentFilter = [];
              RecentFilter = this.coreFilterNameList.filter(x => x.filterID === Number(this.checkRecentFilter[0].value));
              if (RecentFilter.length > 0) {
                if (RecentFilter[0].filterID == "-1") {
                  this.getFavoriteCoreList("");
                  this.Filtername = "Starred";
                }
                else if (RecentFilter[0].filterID == "0") {
                  this.getList("");
                  this.Filtername = "All " + this.Module;
                }
                else if (RecentFilter[0].filterID > "0") {
                  this.FilteredList(RecentFilter[0].filterFieldModels);
                  this.Filtername = RecentFilter[0].filterName;
                }
              } else {
                this.getList("");
                this.Filtername = "All " + this.Module;
              }
            }
          } else {
            this.Filtername = "All " + this.Module;
            this.getList("");
          }
        }
        else {
          this.Filtername = "All " + this.Module;
          this.getList("");
        }
      } else {
        this.Filtername = "All " + this.Module;
        this.getList("");
      }
    }, (error) => {
      this.Filtername = "All " + this.Module;
      this.getList("");
    }, () => {

    });
  }

  OnFilterNameClick(filter) {
    this.archieved = false;
    var filterId = 0;
    var selectedfilterId = filter.filterID;
    if (filter.filterID == 0) {
      if (filter.filterName == "All " + this.Module) {
        this.Filtername = "All " + this.Module;
        this.loaderService.hide();
        this.FilteredfieldsRequestModel = [];
        this.selectedfilterList = [];
        this.SendFilteredNameFromCore = this.Filtername;
        this.getList("");
        filterId = 0;
        this.AddPrefrences(filterId, "CoreRecentFilter")
        return;
      }
      if (filter.filterName == "Recent") {
        if (this.checkRecentFilter.length > 0) {
          var RecentFilter = this.FiltersCompanyDataList.filter(x => x.filterID === Number(this.checkRecentFilter[0].value));
          if (RecentFilter[0].filterName == "All " + this.Module) {
            this.getList("");
            this.Filtername = "All " + this.Module;
            return;
          }
          else if (RecentFilter[0].filterName == "Starred") {
            this.getFavoriteCoreList("");
            this.Filtername = "Starred";
            return;
          }
          else if (RecentFilter[0].filterName != "Starred" && RecentFilter[0].filterName != "All " + this.Module) {
            this.FilteredList(RecentFilter[0].filterFieldModels);
            this.Filtername = RecentFilter[0].filterName;
            return;
          }
        }
        else {
          this.Filtername;
        }
      }
    }
    else if (filter.filterID == -1) {
      if (filter.filterName == "Starred") {
        this.Filtername = "Starred";
        this.getFavoriteCoreList("");
        filterId = -1;
        this.AddPrefrences(filterId, "CoreRecentFilter");
        return;
      }
    }
    else {
      this.FilteredfieldsRequestModel = [];
      this.selectedfilterList = filter;//filter.filterFieldModels;
      this.Filtername = filter.filterName;
      this.SendFilteredNameFromCore = this.Filtername;
      this.FilteredList(this.selectedfilterList);
      this.AddPrefrences(selectedfilterId, "CoreRecentFilter");
    }
  }

  archieved: boolean = false;

  ShowArchivedFilter() {
    this.archieved = true;
    this.getList("");
  }

  AddPrefrences(filterId, key) {
    this.addUserPreferencesModel.userPreferenceID = 0;
    this.addUserPreferencesModel.key = key;
    this.addUserPreferencesModel.value = filterId.toString();
    this.addUserPreferencesModel.userID = this.currentUser.UID;
    this.addUserPreferencesModel.createdBy = this.currentUser.UID;
    this.addUserPreferencesModel.officeID = this.myOfficeID;
    this.addUserPreferencesModel.OfficeIDList = this.OfficeIDList;
    this.coreService.AddPrefrences(this.addUserPreferencesModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  GetExport(result) {
    this.getList("");
  }

  DeleteSelectedRecordForCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      this.deleteCoreModel.userID = this.currentUser.UID;
      this.deleteCoreModel.folderID = this.folderID;//17;
      this.deleteCoreModel.databaseID = Number(this.databaseId);
      this.deleteCoreModel.organizationID = Number(this.organizationId);
      this.deleteCoreModel.officeID = this.myOfficeID;
      this.deleteCoreModel.OfficeIDList = this.OfficeIDList;
      this.deleteCoreModel.coreID = result;
      this.coreService.DeleteCoreTransaction(this.deleteCoreModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
            this.toastr.success('Record delete successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  ArchiveSelectedRecordForCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      var ReqModel = {
        iDs: result,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.coreService.setCoreArchive(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
            this.toastr.success('Record Archived successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  ActivateSelectedRecordForCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      var ReqModel = {
        iDs: result,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.coreService.setCoreActivate(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
            this.toastr.success('Record activated successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  SendtoPendingPatientPCCRecordForCore(result) {
    this.payChekSubmittedResult = result;
    this.paycheckErrorList = [];
    if (result.length > 0 && result != "" && result != undefined) {

      var coreListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          coreID: result[i].selectedRecord,
          subFolderID: result[i].subFolderID,
        }
        coreListForPaychex.push(obj);
      }
      var ReqModel = {
        coreList: coreListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      //return;  
      this.loaderService.show();
      this.coreService.sendToPendingPatientPCC(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check: any = [];
            var checkError = [];
            check = this.responseHolder.data;
            check = check.pccResponses;
            
            let quotaExusted:any;
            let quotaExustedMessage="";
            if (check.length > 0) {
              checkError = check.filter(x => x.errors != null);
              checkError.forEach(ne => {
                ne.errors.forEach(ee => {
               if(ee.code=='100')
               {
                quotaExusted=ee.code;
                quotaExustedMessage=ee.detail;
                var obj = {
                  name: "Temporary API Service Unavailability",
                  code: "API will start functioning at "+new Date(ee.xQuotaTimeToResetDateTime),
                  description: ee.detail,
                }
                this.paycheckErrorList.push(obj);
                this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
               }
                });
                ne.errors=ne.errors.filter(m=>m.type==0);
              });
            if(quotaExusted=='100')
            {
             return;
            }
            checkError = checkError.filter(x => x.errors.length != 0);
              if (checkError.length == 0) {
                this.getList("");
                this.toastr.success('Record added in Pending Patient successfully.', '', {
                  timeOut: 3000,
                });
              } else {

                for (var i = 0, len = checkError.length; i < len; ++i) {

                  let list = []
                  let name = "";
                  list = result.filter(x => x.selectedRecord == Number(checkError[i].coreID));
                  if (list.length > 0) {
                    name = list[0].name;
                  }
                  if (checkError[i].errors != null) {
                    checkError[i].errors.forEach(eelement => {

                      var obj = {
                        name: name,
                        code: eelement.code,
                        description: eelement.detail,
                      }
                      this.paycheckErrorList.push(obj);
                    });
                  }
                }
                this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                this.getList("");
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  paycheckErrorList: any = [] = [];

  SendtoPaychexRecordForCore(result) {
    this.payChekSubmittedResult = result;
    this.paycheckErrorList = [];
    if (result.length > 0 && result != "" && result != undefined) {

      var coreListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          coreID: result[i].selectedRecord,
          subFolderID: result[i].subFolderID,
        }
        coreListForPaychex.push(obj);
      }
      var ReqModel = {
        coreList: coreListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      //return;  
      this.loaderService.show();
      this.coreService.sendToPaychex(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check = [];
            var checkError = [];
            check = this.responseHolder.data.response;
            if (check.length > 0) {
              checkError = check.filter(x => x.status != this.statusConst.statusSuccess);
              if (checkError.length == 0) {
                this.getList("");
                this.toastr.success('Record added in Paychex successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                let list = []
                let name = "";
                list = result.filter(x => x.selectedRecord == Number(checkError[0].data.content[0].employeeId));
                if (list.length > 0) {
                  name = list[0].name;
                }
                for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {

                  //list = result.filter(x=> x.selectedRecord == Number(checkError[i].data.content[0].employeeId));
                  //if(list.length>0){
                  //  name=list[0].name;
                  //}
                  var obj = {
                    name: name,
                    code: checkError[0].data.errors[i].code,
                    description: checkError[0].data.errors[i].description,
                  }
                  this.paycheckErrorList.push(obj);
                }
                this.showPaycheckError();
                this.getList("");
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  showPaycheckError(title: any = null) {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {
      data: {
        list: this.paycheckErrorList,
        title: title,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReCreate = result;
        this.SendtoPaychexRecordForCore(this.payChekSubmittedResult);
      }
    });
  }



  AddFavoriteForFilter(result) {
    this.AddPrefrences(result, "CoreDefaultFilter");
  }

  DeleteFavoriteForFilter(result) {
    this.AddPrefrences("", "CoreDefaultFilter");
  }

  RemoveSelectedFilter(filter) {
    var removefilter = filter;
    var filterID = [];
    filterID.push(removefilter);
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      filterIDList: filterID,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.coreService.RemoveSelectedFilter(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.FilteredfieldsRequestModel = [];
          this.getAllCoreTypeNameFilter();
          this.toastr.success('Filter remove successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  coreIds: any;

  GetRelationsForBroadcast(filter, templateRef: TemplateRef<any>) {
    this.coreIds = filter;
    var ReqModel = {
      UserID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      coreIDs: filter,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.selected = [];
    this.subject = "";
    this.msg = "";
    this.coreService.GetRelationsOfSelectedCores(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreRelationsList = response.data;
          this.dialog.open(templateRef, {
            panelClass: 'custom-modalbox',
          });
          this.stateCtrl.reset();
          this.ShowSubjectMessageButton = false;
          this.MessageTemplateID = 0;
          this.getOfficeMailConfigration();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  FavoriteSelectedRecordAddForCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      this.FavoriteCoreModel.userID = this.currentUser.UID;
      this.FavoriteCoreModel.databaseID = Number(this.databaseId);
      this.FavoriteCoreModel.organizationID = Number(this.organizationId);
      this.FavoriteCoreModel.coreID = result;
      this.FavoriteCoreModel.officeID = this.myOfficeID;
      this.coreService.FavoriteCoreTransaction(this.FavoriteCoreModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  FavoriteSelectedRecordForDeleteCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      this.FavoriteCoreModel.userID = this.currentUser.UID;
      this.FavoriteCoreModel.databaseID = Number(this.databaseId);
      this.FavoriteCoreModel.organizationID = Number(this.organizationId);
      this.FavoriteCoreModel.coreID = result;
      this.FavoriteCoreModel.officeID = this.myOfficeID;
      this.coreService.FavoriteDeleteCoreTransaction(this.FavoriteCoreModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            if (this.Filtername == "Starred") {
              this.getFavoriteCoreList("");
            }
            else {
              this.getList("");
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  FilteredList(result) {
    var chckdata = [];
    chckdata = result.filterFieldModels;
    if (chckdata != undefined) {
      result = result.filterFieldModels;
    }
    if (result.length > 0 && result != "" && result != undefined) {
      this.FilteredfieldsRequestModel = [];
      this.selectedfilterList = result;
      for (let i = 0; i < this.selectedfilterList.length; i++) {
        let getdate;
        var filterValue = "";
        if (this.selectedfilterList[i].filterValue == "Today") {
          getdate = [moment(), moment()];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "This Week") {
          getdate = [moment().startOf('week'), moment().endOf('week')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "Last Week") {
          getdate = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "This Month") {
          getdate = [moment().startOf('month'), moment().endOf('month')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "Last Month") {
          getdate = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else {
          filterValue = this.selectedfilterList[i].filterValue;
        }

        var filterFieldsRequestModel = {
          filterFieldID: this.selectedfilterList[i].fieldID,
          filterFieldValue: filterValue,
          childFieldType: this.selectedfilterList[i].childFieldType
        }
        this.FilteredfieldsRequestModel.push(filterFieldsRequestModel);
      }

      this.filteredCoreVm.PageIndex = this.pageModelData.pageIndex;
      this.filteredCoreVm.PageSize = this.pageModelData.pageSize;
      this.filteredCoreVm.UserID = this.currentUser.UID;
      this.filteredCoreVm.FolderId = this.folderID;//17;
      this.filteredCoreVm.DatabaseID = Number(this.databaseId);
      this.filteredCoreVm.OrganizationID = Number(this.organizationId);
      this.filteredCoreVm.fields = this.FilteredfieldsRequestModel;
      this.filteredCoreVm.userContactID = Number(sessionStorage.getItem('userContactID'));
      this.filteredCoreVm.roleIDList = sessionStorage.getItem('roleIDList').split(',');
      this.filteredCoreVm.officeIDList = this.OfficeIDList;
      this.filteredCoreVm.officeID = this.myOfficeID;
      this.loaderService.show();
      this.coreService.getFilteredCoresList(this.filteredCoreVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.totalCount = response.data.totalcount;
            this.coreList = response.data.transactions;
            sessionStorage.setItem('coreList', JSON.stringify(response.data.transactions));
            this.Allids = response.data.ids;
            this.coreList.map((e) => {
              var data = [];
              data = e.fields.filter((element) => element.fieldName == 'Image');
              if (data.length > 0) {
                let imagepath = data[0].fieldValue;
                if (imagepath != '') {
                  if (imagepath.substring(0, 4) == 'http') {
                    e.fields.forEach((element) => {
                      if (element.fieldName == 'Name') {
                        element.fieldValue = element.fieldValue + ',' + imagepath;
                      }
                    });
                  }
                }
              }
              return e;
            });

            this.coreUserListReceived = true;
            let temGridFinalArray = response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
            let tempgridsettingWithoutName = response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
            tempgridsettingWithoutName.forEach((element) => {
              temGridFinalArray.push(element);
            });
            response.data.gridUserSettings = temGridFinalArray;
            this.coreFieldList = response.data.gridUserSettings;
            this.coreFieldList = this.coreFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');
           
            this.coreListReceived = true;
            this.setListToDisplay();
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
            this.coreList = [];
            this.coreFieldList = [];
            this._returnList = [];
            this.dataSource = new MatTableDataSource();
            this.dataSource.data = [];
            this.dataSource.paginator = null;
            this.dataSource.sort = this.sort;
            this.paginatorTotalLength = 0;
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
    else {
      this.Filtername = "All " + this.Module;
      this.FilteredfieldsRequestModel = [];
      this.getList("");
      this.getAllCoreTypeNameFilter();
      this.clmshow = false;
      this.cdr.detectChanges();
    }
  }

  extractDate(value) {
    if (!value) return ''; // Return empty string if value is null, undefined, or empty

    // Regular expression to match common date patterns, including YYYY-MM-DD and YYYY-MM-DD HH:MM AM/PM
    const datePattern = /^(\d{4})-(\d{2})-(\d{2})/;

    // Extract the date part using the regex pattern
   
    const match = value.match(datePattern);
    if (match) {
        const [_, year, month, day] = match; // Extract year, month, day from regex match
    
        const date= new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
        return date;
    }
    else
    {
      return value;
    }
  
    // If no valid date found, return an empty string
   
}


  convertToUTCDate(dateString: string): Date | string {
    if (!dateString) return '';
    // Split the date and time parts by 'T'
    const [datePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number)
    const date= new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
    //let newUTCDate=this.formatAsUTC(date); 
    return date;
  }

  getAllCoreTypeNameFilter() {
    this.corefilterData.databaseID = Number(this.databaseId);
    this.corefilterData.organizationID = Number(this.organizationId);
    this.corefilterData.userID = this.currentUser.UID;
    this.corefilterData.folderID = this.folderID;//17;
    this.corefilterData.officeID = this.myOfficeID;
    this.corefilterData.OfficeIDList = this.OfficeIDList;
    this.coreService.getAllCoreTypeFilterList(this.corefilterData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreFilterNameList = [];
          var newlist = [];
          var AllCore: any;
          var AllFav: any;
          var Recent: any;
          var AllReviewer: any;

          AllCore = {
            filterID: 0,
            filterName: "All " + this.Module,
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          AllFav = {
            filterID: -1,
            filterName: "Starred",
            folderID: this.folderID,// 17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          Recent = {
            filterID: 0,
            filterName: "Recent",
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          AllReviewer = {
            filterID: -2,
            filterName: "Review",
            folderID: this.folderID,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }

          this.coreFilterNameList.push(AllCore);//this.AllCore
          this.coreFilterNameList.push(AllFav);//this.AllFav
          this.coreFilterNameList.push(Recent);//this.Recent
          this.coreFilterNameList.push(AllReviewer);//this.Reviewer        

          newlist = response.data;
          for (var i = 0, len = newlist.length; i < len; ++i) {
            this.coreFilterNameList.push(newlist[i]);
          }
          if (response.data) {
            this.FiltersCompanyDataList = response.data;
            let localFilters = response.data.map(({ filterName }) => filterName);
            sessionStorage.setItem('localFilters', localFilters);
            this.GetUserPreferences();
          }
        }
        else {
          this.coreFilterNameList = [];
          AllCore = {
            filterID: 0,
            filterName: "All " + this.Module,
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          AllFav = {
            filterID: -1,
            filterName: "Starred",
            folderID: this.folderID,// 17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          this.coreFilterNameList.splice(0, 0, AllCore); //this.AllCore
          this.coreFilterNameList.splice(1, 1, AllFav); //this.AllFav
          this.Filtername = "All " + this.Module;
          sessionStorage.setItem('localFilters', "");
          this.GetUserPreferences();
        }
      }
    });
  }

  clearAllApplyFilter(result) {
    this.Filtername = "All " + this.Module;
    //this.getAllCoreTypeNameFilter();
    this.getCloseFilter(false);
    this.FilteredfieldsRequestModel = [];
    this.getList("");
    this.clmshow = false;
    this.cdr.detectChanges();
  }

  closepaycheckError() {
    this.dialog.closeAll();
  }


  setDisplayedColumns() {
    this.displayedColumns = [];
    this.isAnyRecordAvailable && this.coreFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });
  }

  dragStarted(event: CdkDragStart, index: number) {
    this.previousIndex = index;
  }

  dropListDropped(event: CdkDragDrop<string[]>) {
    if (event.currentIndex == 0) return false;
    if (event.previousIndex == 0) return false;

    moveItemInArray(
      this.coreFieldListNew,
      event.previousIndex,
      event.currentIndex
    );

    this.columnData = [];

    for (let index = 1; index < this.coreFieldListNew.length; index++) {
      var req = {
        fieldID: this.coreFieldListNew[index].fieldID,
        viewOrder: index + 0,
        isDisplay: true
      }
      this.columnData.push(req);
    }

    this.setDisplayedColumns();

    var ReqModel = {
      userID: this.currentUser.UID,
      columnData: this.columnData,
      folderID: this.folderID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.coreService.ReorderCoreFieldColumnList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getList("");
          this.columnData = [];
        }
      }
    });
  }


  setListForDrogandDrop(list: any[]): any[] {
    var tempList: any[] = list.map((s) => Object.assign(s));
    let returnList = [];
    var favorite: Boolean = false;
    var paychexID;
    var pendingPatientId;
    tempList.forEach((element) => {
      let ReqModel = {};
      let coreID = 0;
      let TypeID = 0;
      favorite = element.isFavorite;
      paychexID = element.paychexID;
      pendingPatientId=element.pendingPatientId
      element.fields.forEach((ele) => {
        if (ele.coreID != undefined) {
          coreID = ele.coreID;
        }
        if (ele.fieldName == "Type") {
          TypeID = ele.subFolderID;
        }
        
        var timestamp = Date.parse(ele.fieldValue);

        if (isNaN(timestamp) == false && ele.fieldTypeID == 4) {
          ReqModel[ele.fieldName] = this.datepipe.transform(
            ele.fieldValue,
            'MM/dd/yyyy'
          );
        } else {
          if (ele.fieldName == 'Address') {
            if (ReqModel["Address"] == undefined) {
              let addressFieldValues = "";
              let AddressFieldCollection = element.fields.filter(m => m.fieldName == 'Address' && m.childFieldType == 0 && m.fieldValue != '');
              if (AddressFieldCollection.length > 0) {
                addressFieldValues = addressFieldValues + AddressFieldCollection[0].fieldValue;

                ReqModel[ele.fieldName] = addressFieldValues + " " + element.fields.find(m => m.childFieldType == 3 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 2 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 4 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
              } else {
                ReqModel[ele.fieldName] = '—';
              }
            }
          }
          else
            ReqModel[ele.fieldName] = ele.fieldValue ? ele.fieldValue : '—';
        }
      });
      ReqModel['CoreID'] = coreID;
      ReqModel['IsFavorite'] = favorite;
      ReqModel['paychexID'] = paychexID;
      ReqModel['pendingPatientId'] = pendingPatientId;
      ReqModel['TypeID'] = TypeID;
      returnList.push(ReqModel);
    });
    return returnList;
  }

  setListForDrogandDrop1(list: any[]): any[] {
    var tempList: any[] = list.map((s) => Object.assign(s));
    let returnList = [];
    var favorite: Boolean = false;
    var paychexID;
    var pendingPatientId;
    tempList.forEach((element) => {
      let ReqModel = {};
      let coreID = 0;
      let TypeID = 0;
      favorite = element.isFavorite;
      paychexID = element.paychexID;
      pendingPatientId=element.pendingPatientId
      element.fields.forEach((ele) => {
        if (ele.coreID != undefined) {
          coreID = ele.coreID;
        }
        if (ele.fieldName == "Type") {
          TypeID = ele.subFolderID;
        }
        
        if (ele.fieldName == "Name") {
          ele.fieldValue = this.getFullName(ele.fieldValue);
        }

        var timestamp = Date.parse(ele.fieldValue);

        if (isNaN(timestamp) == false && ele.fieldTypeID == 4) {
          ReqModel[ele.fieldName] = this.datepipe.transform(
            ele.fieldValue,
            'MM/dd/yyyy'
          );
        } else {
          if (ele.fieldName == 'Address') {
            if (ReqModel["Address"] == undefined) {
              let addressFieldValues = "";
              let AddressFieldCollection = element.fields.filter(m => m.fieldName == 'Address' && m.childFieldType == 0 && m.fieldValue != '');
              if (AddressFieldCollection.length > 0) {
                addressFieldValues = addressFieldValues + AddressFieldCollection[0].fieldValue;

                ReqModel[ele.fieldName] = addressFieldValues + " " + element.fields.find(m => m.childFieldType == 3 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 2 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 4 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
              } else {
                ReqModel[ele.fieldName] = '—';
              }
            }
          }
          else
            ReqModel[ele.fieldName] = ele.fieldValue ? ele.fieldValue : '—';
        }
      });
      ReqModel['CoreID'] = coreID;
      ReqModel['IsFavorite'] = favorite;
      ReqModel['paychexID'] = paychexID;
      ReqModel['pendingPatientId'] = pendingPatientId;
      ReqModel['TypeID'] = TypeID;
      returnList.push(ReqModel);
    });
    return returnList;
  }

  getFullName(fullName) {
    var tarea = fullName;
    if (/(http(s?)):\/\//i.test(tarea)) {
      fullName = fullName;
      fullName = fullName.split(',');
      return fullName[0];
    } else {
      fullName = fullName;
      return fullName;
    }
  }

  getFavoriteCoreList(searchKey: string) {
    this.coreList = [];
    this.coreVm.PageIndex = this.pageModelData.pageIndex;
    this.coreVm.PageSize = this.pageModelData.pageSize;
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.FolderId = this.folderID;//17;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.coreVm.officeID = this.myOfficeID;
    this.coreService.getCoreFavoriteList(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.coreFieldColumnToogle = [];
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.totalCount = response.data.totalcount;
          this.coreList = response.data.transactions;
          sessionStorage.setItem('coreList', JSON.stringify(response.data.transactions));
          this.Allids = response.data.ids;
          this.coreList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.coreUserListReceived = true;
          let temGridFinalArray = response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.coreFieldList = response.data.gridUserSettings;
          this.coreFieldList = this.coreFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');

          this.coreFieldListNew = this.coreFieldList.filter((s) => s.fieldName != 'Image');

          this.coreListReceived = true;
          this.coreFieldColumnToogle = response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.setDisplayedColumns();
          this.setListToDisplay();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
          this.coreList = [];
          this.coreFieldList = [];
          this._returnList = [];
          this.dataSource = new MatTableDataSource();
          this.dataSource.data = [];
          this.dataSource.paginator = null;
          this.dataSource.sort = this.sort;
          this.paginatorTotalLength = 0;
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  statusColorList: any;

  getList(searchKey: string) {
    if (this.FilteredfieldsRequestModel.length > 0 && this.FilteredfieldsRequestModel != undefined) {
      return;
    }
    this.coreList = [];
    this.coreVm.FolderId = this.folderID;
    this.coreVm.PageIndex = this.pageModelData.pageIndex;
    this.coreVm.PageSize = this.pageModelData.pageSize;
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.FolderId = this.folderID;//17;
    this.coreVm.searchKey = this.value.trim();
    this.coreVm.userContactID = Number(sessionStorage.getItem('userContactID'));
    this.coreVm.RoleIDList = sessionStorage.getItem('roleIDList').split(',');
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.isArchived = this.archieved;
    this.loaderService.show();
    this.coreService.getCoreList(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.coreFieldColumnToogle = [];
        this.responseHolder = response;
      

        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.statusColorList = response.data.defaultKanbanColumn  
          this.isAnyRecordAvailable = response.data.isAnyRecordAvailable;
          this.totalCount = response.data.totalcount;
          this.coreList = this.isAnyRecordAvailable ? response.data.transactions : [];
          sessionStorage.removeItem("coreList");
          const sizeInKB = new Blob([JSON.stringify(response.data.transactions)]).size / 1024;
          
          //sessionStorage.setItem('coreList', JSON.stringify(response.data.transactions));
          if (sizeInKB < 5000) {  // 5MB limit
            sessionStorage.setItem('coreList', JSON.stringify(response.data.transactions));
           } else {
            console.warn('coreList size exceeds 5MB, not storing in sessionStorage');
          }
          this.Allids = response.data.ids;
          this.coreList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.coreUserListReceived = true;
          let temGridFinalArray = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          this.isAnyRecordAvailable && tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.coreFieldList = response.data.gridUserSettings;
          if(this.coreFieldList.length>0){
            this.coreFieldList.forEach((ele) => {
              if (ele.fieldName == "Status") {
                ele.isDisplay=true;           
              }
            });
          }         

          this.coreFieldList = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');
          this.coreFieldList = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.availableOn != 2);
          this.coreFieldList = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.rolePermission != 2);

          this.coreFieldListNew = this.isAnyRecordAvailable && this.coreFieldList.filter((s) => s.fieldName != 'Image');

          this.coreListReceived = true;
          this.coreFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.coreFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.rolePermission != 2);
          this.coreFieldColumnToogle = this.isAnyRecordAvailable && this.coreFieldColumnToogle.filter((s) => s.availableOn != 2);
        
                             
          //this.setListForToggle();
          this.setDisplayedColumns();
          this.setListToDisplay();
          this.loaderService.hide();
        } else {
          this.isAnyRecordAvailable = false;
          this.loaderService.hide();
          this.coreList = [];
          this.coreFieldList = [];
          this._returnList = [];
          this.dataSource = new MatTableDataSource();
          this.dataSource.data = [];
          this.dataSource.paginator = null;
          this.dataSource.sort = this.sort;
          this.paginatorTotalLength = 0;
        }
      } else {
        this.isAnyRecordAvailable = false;
        this.loaderService.hide();
      }
    });
  }



  setListToDisplay() {
    if (this.coreUserListReceived && this.coreListReceived) {
      this.diplayList = [];
      var favorite: boolean = false;
      for (var user = 0; user < this.coreList.length; user++) {
        let tempUserFields: any[] = [];
        for (var coreField = 0; coreField < this.coreFieldList.length; coreField++) {
          let fieldFound = false;
          for (var userField = 0; userField < this.coreList[user].fields.length; userField++) {
            try {
              this.coreList[user].fields[userField].fieldValue= this.extractDate(this.coreList[user].fields[userField].fieldValue);
            } catch (error) {
            }
            if (this.coreFieldList[coreField].fieldID == this.coreList[user].fields[userField].fieldID) {
              fieldFound = true;
              tempUserFields.push(this.coreList[user].fields[userField]);
              //break;
            }
            if (userField + 1 == this.coreList[user].fields.length && fieldFound == false) {
              var fieldValue = "";
              if(this.coreFieldList[coreField].fieldName=="Status"){
                var check=[];
                check=this.coreList.filter(x=>x.coreID == this.coreList[user].fields[0].coreID);
                if(check.length>0){
                  fieldValue=check[0].status;
                }else{
                  fieldValue="";
                }
              }
              var ReqModel = {
                fieldID: this.coreFieldList[coreField].fieldID,
                fieldName: this.coreFieldList[coreField].fieldName,
                fieldTypeID: this.coreFieldList[coreField].fieldTypeID,
                fieldTypeName: this.coreFieldList[coreField].fieldTypeName,
                fieldValue: fieldValue,
                transactionID: this.coreList[user].fields[0].coreID,
              };
              tempUserFields.push(ReqModel);
            }
          }
        }
        var _user = {
          fields: tempUserFields,
          transactionID: tempUserFields[0].coreID,
          isFavorite: this.coreList[user].isFavorite,
          paychexID: this.coreList[user].paychexID,
          pendingPatientId:this.coreList[user].pendingPatientId
        };
        this.diplayList.push(_user);
      }
    }

    this.coreListNew = [];
    this.coreListNew = this.diplayList;

    this._returnList = this.setListForDrogandDrop(this.coreListNew);
   // this._returnList1 = this.setListForDrogandDrop1(this.coreListNew);

    if (this._returnList && this._returnList[0] && this._returnColumns) {
      for (var prop in this._returnList[0]) {
        this._returnColumns.push(prop);
      }
    }

    this.isAnyRecordAvailable && this.coreFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });

    this.dataSource = new MatTableDataSource();
    this.dataSource.data = this._returnList;
    this.dataSource.paginator = null;
    this.dataSource.sort = this.sort;
    this.pageIndex = this.pageModelData.pageIndex;
    this.pageSize = this.pageModelData.pageSize;
    this.paginatorTotalLength = this.totalCount;
  }

  clearFilter() {
    this.value = "";
    this.filterText = "";
    this.pageModelData.pageIndex=0;
    this.getList(this.filterText);
  }

  // to filter based on search $$....
  SearchRecord(filterValue) {
    this.filterText = filterValue.trim();
    this.pageModelData.pageIndex=0;
    this.value = this.filterText;
    this.getList(this.filterText);
    return;
  }

  onSubmitColumns(result) {
    this.updateColumnCoreVm.UserID = this.currentUser.UID;
    this.updateColumnCoreVm.DatabaseID = Number(this.databaseId);
    this.updateColumnCoreVm.OrganizationID = Number(this.organizationId);
    this.updateColumnCoreVm.officeID = this.myOfficeID;
    this.updateColumnCoreVm.OfficeIDList = this.OfficeIDList;
    this.updateColumnCoreVm.CustomizationGridUserSetting = result;
    this.coreService.updateCoreFieldColumnList(this.updateColumnCoreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.close();
          this.getList("");
        }
      }
    });
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue = this.value.trim();
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    if (this.Filtername == "All " + this.Module) {
      if (this.selectedfilterList.length > 0) {
        this.FilteredList(this.selectedfilterList);
      } else {
        this.getList(this.value.trim());
      }
    }
    else {
      if (this.selectedfilterList.length > 0) {
        this.FilteredList(this.selectedfilterList);
      } else {
        this.getList(this.value.trim());
      }
    }

  }

  broadcastMsg() {
    if (this.SendtoSelectedCores == false) {
      if (this.selected.length == 0) {
        this.toastr.warning("Select relation to proceed.");
        return;
      }
    }
    if (this.subject == "") {
      this.toastr.warning("Enter subject");
      return;
    }
    if (this.msg == "") {
      this.toastr.warning("Enter message.");
      return;
    }
    else {
      var ReqModel = {
        UserID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        coreContactIdList: this.selected,
        subject: this.subject,
        message: this.msg,
        sendEmailOrMsg: this.isChecked,
        officeID: this.myOfficeID,
        OfficeIDList: this.OfficeIDList,
        isSelectedCore: this.SendtoSelectedCores,
        coreIDs: this.coreIds
      }
      //return;
      this.coreService.sendBroadcastMsgToRelations(ReqModel).subscribe(response => {
        if (response.status == this.statusConst.statusSuccess) {
          this.getList("");
          this.toastr.success('Broadcast message send successfully .', '', {
            timeOut: 3000,
          });
          this.stateCtrl.reset();
          this.MessageTemplateID = 0;
          this.dialog.closeAll();
        }
      });
    }
  }

  subjectList: any = [];
  timeout = null;
  ShowSubjectMessageButton: boolean = false;
  SubjectMessageButton: boolean = false;
  spinner: boolean = false;
  MessageTemplateID: number = 0;

  searchSubject(val) {
    if (this.subject != "" && this.msg != "") {
      // this.ShowSubjectMessageButton=true;
      this.SubjectMessageButton = false;
      if (this.MessageTemplateID > 0) {
        this.ShowSubjectMessageButton = false;
      } else {
        this.ShowSubjectMessageButton = true;
      }

      if (val != '' && val.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getSubjectTemplate(val)
        }, 500);
      }
    } else {
      this.ShowSubjectMessageButton = false;
      this.SubjectMessageButton = false;
      this.subjectList = [];
      if (val != '' && val.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getSubjectTemplate(val)
        }, 500);
      } else {
        this.subjectList = [];
      }
    }
  }

  CheckMessage(val) {
    if (this.subject != "" && this.msg != "") {
      if (this.MessageTemplateID > 0) {
        this.ShowSubjectMessageButton = false;
      } else {
        this.ShowSubjectMessageButton = true;
      }
    } else {
      this.ShowSubjectMessageButton = false;
    }
  }

  getSubjectTemplate(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      SearchKey: searchValue,
      officeID: this.myOfficeID
    }
    this.spinner = false;
    this.coreService.SearchSubjectTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.subjectList = response.data;
          if (this.subject != "" && this.msg != "") {
            this.ShowSubjectMessageButton = true;
          } else {
            this.ShowSubjectMessageButton = false;
          }
        } else {
          this.subjectList = [];
          this.MessageTemplateID = 0;
          if (this.subject != "" && this.msg != "") {
            this.ShowSubjectMessageButton = true;
          } else {
            this.ShowSubjectMessageButton = false;
          }
        }
      } else {
        this.subjectList = [];
        this.MessageTemplateID = 0;
        if (this.subject != "" && this.msg != "") {
          this.ShowSubjectMessageButton = true;
        } else {
          this.ShowSubjectMessageButton = false;
        }
      }
    }
    )
  }

  subjectSelected(subject: any) {
    if (subject.messageTemplateID > 0) {
      this.msg = subject.message;
      this.subject = subject.subject;
      this.ShowSubjectMessageButton = false;
      this.MessageTemplateID = subject.messageTemplateID;
    } else {
      this.MessageTemplateID = 0;
      this.ShowSubjectMessageButton = false;
    }
  }

  onEnterSubject(event, subject) {
    var findSubject = [];
    findSubject = this.subjectList.filter((x) => x.subject === event.target.value);
    if (findSubject.length > 0) {
      this.msg = findSubject[0].message;
      this.subject = findSubject[0].subject;
      this.ShowSubjectMessageButton = false;
      this.MessageTemplateID = findSubject[0].messageTemplateID;
    }
  }

  AddSubjectMessageTemplate() {
    this.subject = this.stateCtrl.value;
    var ReqModel = {
      messageTemplateID: 0,
      typeID: MessageTemplate.BroadCast,  // 1-Brodcast , 2-Request , 3-Fax , 4-Project   
      subject: this.subject,
      message: this.msg,
      UserID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.spinner = true;
    this.SubjectMessageButton = true;
    this.coreService.AddUpdateSubjectMessageTemplate(ReqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.ShowSubjectMessageButton = false;
        this.SubjectMessageButton = false;
      }
    });
  }

  SendtoSelectedCores: boolean = false;

  SelectedCore(event) {
    if (event.checked == true) {
      this.SendtoSelectedCores = true;
    } else {
      this.SendtoSelectedCores = false;
    }
  }

  addNew(message) {
    this.addListing = !this.addListing;
  }

  getClose(message) {
    this.addListing = message;
  }

  close() {
    this.stateCtrl.reset();
    this.ShowSubjectMessageButton = false;
    this.MessageTemplateID = 0;
    this.dialog.closeAll();
  }

  closebroadcast() {
    this.getList("");
    this.stateCtrl.reset();
    this.ShowSubjectMessageButton = false;
    this.MessageTemplateID = 0;
    this.dialog.closeAll();
  }

  CloseAttachToTaskList() {
    this.getList("");
    this.stateCtrl.reset();
    this.ShowSubjectMessageButton = false;
    this.MessageTemplateID = 0;
    this.dialog.closeAll();
  }

  customizeColumn(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }
  

  getapplyFilter(message) {
    this.showFilter = !this.showFilter;
  }


  getCloseFilter(message) {
    this.showFilter = message;
    //this.getAllCoreTypeNameFilter();
  }

  getCloseFilterAfterSave(message) {
    this.showFilter = message;
    this.getAllCoreTypeNameFilter();
  }

  getshowRightSidePanel(message) {
    this.showDetail = true;
  }

  getselectedTransactionId(result) {
    this.selectedtransactionId = result;
  }
  getCloseDetail(message) {
    this.showDetail = message;
  }


  showAttachToTaskList: boolean = false;
 
  SelectedRecordToAttachTaskList(result) {
    if (result.length > 0 && result != "" && result != undefined) {
       this.showAttachToTaskList = true;
    }
  }

  disabledEmailNotification:boolean=false;

  getOfficeMailConfigration() {
    var ReqModel = {     
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),     
      officeID: this.myOfficeID
    };   
    this.coreService.getOfficeMailConfigration(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;      
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if(this.responseHolder.data.eMailConfigeType==0){
            this.disabledEmailNotification=true;
          }else{
            this.disabledEmailNotification=false;
          }
        //  if(this.responseHolder.data.isCustomSMTP==true){
        //   if(this.responseHolder.data.smtpDetails!=null){
        //     this.disabledEmailNotification=false;
        //   }else{
        //     this.disabledEmailNotification=true;
        //    }
        //  }else{
        //   this.disabledEmailNotification=true;
        //  }
        }
      }else{
       
      }
    });
   }

}
